<template>
  <div class="page-card">
    <el-card>
      <div slot="header">系统管理 - 系统配置</div>
      <el-form :inline="true" size="small" @submit.native.prevent>
        <el-form-item label="配置键">
          <el-input v-model="query.key" placeholder="配置键" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchList">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="success" @click="openEdit()">新增配置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="filteredList" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="key" label="配置键" width="220" />
        <el-table-column prop="value" label="配置值" />
        <el-table-column prop="description" label="说明" width="220" />
        <el-table-column prop="updatedAt" label="更新时间" width="180" />
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
        :title="editForm.id ? '编辑配置' : '新增配置'"
        :visible.sync="editVisible"
        width="600px"
      >
        <el-form :model="editForm" label-width="80px">
          <el-form-item label="配置键">
            <el-input v-model="editForm.key" :disabled="!!editForm.id" />
          </el-form-item>
          <el-form-item label="配置值">
            <el-input
              type="textarea"
              :rows="6"
              v-model="editForm.value"
              placeholder="可填字符串或 JSON，用于系统开关、告警阈值等"
            />
          </el-form-item>
          <el-form-item label="说明">
            <el-input v-model="editForm.description" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveConfig">保 存</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from '@/api/request'

export default {
  name: 'SystemConfigList',
  data() {
    return {
      query: {
        key: ''
      },
      list: [],
      editVisible: false,
      editForm: {
        id: null,
        key: '',
        value: '',
        description: ''
      }
    }
  },
  computed: {
    filteredList() {
      if (!this.query.key) return this.list
      const k = this.query.key.toLowerCase()
      return this.list.filter(item => (item.key || '').toLowerCase().includes(k))
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      request.get('/configs').then(res => {
        const data = res.data || res
        this.list = (data && data.items) || []
      })
    },
    resetQuery() {
      this.query.key = ''
      this.fetchList()
    },
    openEdit(row) {
      if (row) {
        this.editForm = {
          id: row.id,
          key: row.key,
          value: row.value,
          description: row.description
        }
      } else {
        this.editForm = {
          id: null,
          key: '',
          value: '',
          description: ''
        }
      }
      this.editVisible = true
    },
    saveConfig() {
      if (!this.editForm.key) {
        this.$message.warning('请填写配置键')
        return
      }
      const payload = {
        key: this.editForm.key,
        value: this.editForm.value,
        description: this.editForm.description
      }
      request.post('/configs', payload).then(() => {
        this.$message.success('保存成功')
        this.editVisible = false
        this.fetchList()
      })
    },
    remove(row) {
      if (!row || !row.id) return
      this.$confirm(`确认删除该配置：${row.key} ?`, '提示', { type: 'warning' }).then(() => {
        request.delete(`/configs/${row.id}`).then(() => {
          this.$message.success('删除成功')
          this.fetchList()
        })
      })
    }
  }
}
</script>

